const replaceUrlQueryString = (history, data) => {
    const params = new URLSearchParams({ ...data }).toString();
    history.push({
      search: "?" + params,
    });
};

export const handlers = {
  replaceUrlQueryString
};